import { TempStat } from "../api-objects/TempStat";
import { BASE_URL, requestOptionsGET } from "../Constants";

export async function getStatsByEmail(email: string, idToken: string): Promise<any> {
    try {
        const response = await fetch(`${BASE_URL}/api/temp-stats/email/${email}`, requestOptionsGET(idToken));

        if (response.ok) {
            const rows = await response.json();
            return rows;
        } else {
            // Log error details for non-200 status
            console.error("Error response:", await response.text());
            return [];
        }
    } catch (error) {
        console.log("Error fetching statistics:", error);
        return [];
    }
}

export async function getAllStats(idToken: string): Promise<TempStat[]> {
    try {
        const response = await fetch(`${BASE_URL}/api/temp-stats/all-data`, requestOptionsGET(idToken));

        if (response.ok) {
            const stats: TempStat[] = await response.json();
            return stats;
        } else {
            console.error("Error response:", await response.text());
            return [];
        }
    } catch (error) {
        console.log("Error fetching statistics:", error);
        return [];
    }
}

export async function getEventsByUserAndEvent(
    idToken: string,
    patient_id: string,
    event_type: string,
): Promise<any> {
    try {
        const response = await fetch(`${BASE_URL}/api/events/user/${patient_id}/event/${event_type}`, requestOptionsGET(idToken));

        if (response.ok) {
            const event = await response.json();
            return event;
        } else {
            console.error("Error response:", await response.text());
            return [];
        }
    } catch (error) {
        console.log("Error fetching events:", error);
        return [];
    }
}

export async function getAllNotifications(idToken: string): Promise<any> {
    try {
        console.log("trying")
        const response = await fetch(`${BASE_URL}/api/notifications/all`, requestOptionsGET(idToken));

        if (response.ok) {
            const notifications = await response.json();
            return notifications;
        } else {
            console.error("Error response:", await response.text());
            return [];
        }
    } catch (error) {
        console.log("Error fetching statistics:", error);
        return [];
    }
}

export async function updateUserInfoWithSwabcode(
    userId: string,
    idToken: string,
    swabcode: string | null,
    onSuccess: () => void,
    onError: (error: string) => void,
) {
    try {
        const response = await fetch(`${BASE_URL}/api/users/${userId}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': idToken,
            },
            body: JSON.stringify
                ({
                    swabcode,
                })
        })
        if (response.ok) {
            const user = await response.json()
            console.log(user)
            onSuccess()
        } else {
            onError("Codice non valido")
        }
    } catch (error) {
        console.error("Update user info failed:", error);
        return { success: false, error: "An unexpected error occurred" };
    }
}

export async function getUserById(userId: string, idToken: string): Promise<any> {
    try {
        const response = await fetch(`${BASE_URL}/api/users/${userId}`, requestOptionsGET(idToken));
        if (response.ok) {
            const user = await response.json();
            return user;
        } else {
            // Log error details for non-200 status
            console.error("Error response:", await response.text());
            return null;
        }
    } catch (error) {
        console.log("Error fetching user by id:", error);
        return null;
    }
}